import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  env: localStorage.getItem('playerList.env') || 'newList',
  rootUrl: null,
  loading: true,
  settings: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app/index.js